<template>
  <nav
    v-if="filters"
    class="m-filters__group u-mt-0"
  >
    <slot></slot>

    <div
      v-if="districts.length"
      class="m-filters__filter"
    >
      <BaseDropdownButton
        v-if="asDropdown"
        :title="districtsTitle"
        id="filter-district-label"
      >
        <ul class="m-filters__filter-list">
          <li v-for="district in districts" :key="district.id">
            <div class="a-checkbox">
              <input
                class="a-checkbox__el"
                type="checkbox"
                :id="'filter-district-' + district.id"
                aria-describedby="filter-district-label"
                :value="district.id"
                v-model="localDistricts"
                @change="$emit('update:filterDistricts', localDistricts)"
              >
              <label
                class="a-checkbox__label"
                :for="'filter-district-' + district.id"
                v-text="district.title"
              ></label>
            </div>
          </li>
        </ul>
      </BaseDropdownButton>

      <template v-else>
        <h3 class="a-h4" id="filter-district-label">{{ $t('filters.district') }}</h3>
        <ul class="m-filters__filter-list">
          <li v-for="district in districts" :key="district.id">
            <div class="a-checkbox">
              <input
                class="a-checkbox__el"
                type="checkbox"
                :id="'filter-district-' + district.id"
                aria-describedby="filter-district-label"
                :value="district.id"
                v-model="localDistricts"
                @change="$emit('update:filterDistricts', localDistricts)"
              >
              <label
                class="a-checkbox__label"
                :for="'filter-district-' + district.id"
                v-text="district.title"
              ></label>
            </div>
          </li>
        </ul>
      </template>
    </div>

    <div
      v-if="months.length"
      class="m-filters__filter"
    >
      <BaseDropdownButton
        v-if="asDropdown"
        :title="monthsTitle"
        id="filter-month-label"
      >
        <ul class="m-filters__filter-list">
          <li v-for="month in months" :key="month.id">
            <div class="a-checkbox">
              <input
                class="a-checkbox__el"
                type="checkbox"
                :id="'filter-month-' + month.id"
                aria-describedby="filter-month-label"
                :value="month.id"
                v-model="localMonths"
                @change="$emit('update:filterMonths', localMonths)"
              >
              <label
                class="a-checkbox__label"
                :for="'filter-month-' + month.id"
                v-text="label(month)"
              ></label>
            </div>
          </li>
        </ul>
      </BaseDropdownButton>

      <template v-else>
        <h3 class="a-h4" id="filter-month-label">{{ $t('filters.month') }}</h3>
        <ul class="m-filters__filter-list">
          <li v-for="month in months" :key="month.id">
            <div class="a-checkbox">
              <input
                class="a-checkbox__el"
                type="checkbox"
                :id="'filter-month-' + month.id"
                aria-describedby="filter-month-label"
                :value="month.id"
                v-model="localMonths"
                @change="$emit('update:filterMonths', localMonths)"
              >
              <label
                class="a-checkbox__label"
                :for="'filter-month-' + month.id"
                v-text="label(month)"
              ></label>
            </div>
          </li>
        </ul>
      </template>
    </div>

    <div
      v-if="years.length"
      class="m-filters__filter"
    >
      <BaseDropdownButton
        v-if="asDropdown"
        :title="yearsTitle"
        id="filter-year-label"
      >
        <ul class="m-filters__filter-list">
          <li v-for="year in years" :key="year.id">
            <div class="a-checkbox">
              <input
                class="a-checkbox__el"
                type="checkbox"
                :id="'filter-year-' + year.id"
                aria-describedby="filter-year-label"
                :value="year.id"
                v-model="localYears"
                @change="$emit('update:filterYears', localYears)"
              >
              <label
                class="a-checkbox__label"
                :for="'filter-year-' + year.id"
                v-text="label(year)"
              ></label>
            </div>
          </li>
        </ul>
      </BaseDropdownButton>

      <template v-else>
        <h3 class="a-h4" id="filter-month-label">{{ $t('filters.year') }}</h3>
        <ul class="m-filters__filter-list">
          <li v-for="year in years" :key="year.id">
            <div class="a-checkbox">
              <input
                class="a-checkbox__el"
                type="checkbox"
                :id="'filter-year-' + year.id"
                aria-describedby="filter-year-label"
                :value="year.id"
                v-model="localYears"
                @change="$emit('update:filterYears', localYears)"
              >
              <label
                class="a-checkbox__label"
                :for="'filter-year-' + year.id"
                v-text="label(year)"
              ></label>
            </div>
          </li>
        </ul>
      </template>
    </div>
  </nav>
</template>

<script>
import BaseDropdownButton from './BaseDropdownButton.vue'

export default {
  components: {
    BaseDropdownButton,
  },

  props: {
    asDropdown: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      required: true,
    },
    filterDistricts: {
      type: Array,
      default: () => {
        return [];
      },
    },
    filterMonths: {
      type: Array,
      default: () => {
        return [];
      },
    },
    filterYears: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => ({
    localDistricts: [],
    localMonths: [],
    localYears: [],
  }),
  computed: {
    districts() {
      if (!this.filters || !this.filters.districts) {
        return [];
      }

      return this.filters.districts.filter((district) => district.count > 0);
    },

    districtsTitle() {
      const label = this.$t('filters.district');

      return label + (this.localDistricts.length ? ' (' + this.localDistricts.length +')' : '');
    },

    months() {
      if (!this.filters || !this.filters.months) {
        return [];
      }

      return this.filters.months.filter((month) => month.count > 0);
    },

    monthsTitle() {
      const label = this.$t('filters.month');

      return label + (this.localMonths.length ? ' (' + this.localMonths.length +')' : '');
    },

    years() {
      if (!this.filters || !this.filters.years) {
        return [];
      }

      return this.filters.years.filter((year) => year.count > 0);
    },

    yearsTitle() {
      const label = this.$t('filters.year');

      return label + (this.localYears.length ? ' (' + this.localYears.length +')' : '');
    },
  },
  mounted() {
    this.localDistricts = this.filterDistricts.slice();
    this.localMonths = this.filterMonths.slice();
    this.localYears = this.filterYears.slice();
  },
  watch: {
    filterDistricts() {
      this.localDistricts = this.filterDistricts.slice();
    },

    filterMonths() {
      this.localMonths = this.filterMonths.slice();
    },

    filterYears() {
      this.localYears = this.filterYears.slice();
    },
  },
  methods: {
    label(item) {
      return item.title + ' (' + item.count + ')'
    }
  }
}
</script>
